import { render, staticRenderFns } from "./AuditTable.template.vue?vue&type=template&id=23a10534&scoped=true&"
var script = {}
import style0 from "./AuditTable.template.vue?vue&type=style&index=0&id=23a10534&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a10534",
  null
  
)

export default component.exports